// extracted by mini-css-extract-plugin
export default {"videoContainer":"ProjectVideoPlayer_videoContainer__EYdFO"};